
import { useState, useCallback } from 'react';

interface UseOptimizedCarouselProps {
  itemsLength: number;
  autoPlay?: boolean;
  autoPlayDelay?: number;
}

export const useOptimizedCarousel = ({ 
  itemsLength, 
  autoPlay = false, 
  autoPlayDelay = 4000 
}: UseOptimizedCarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = useCallback(() => {
    if (itemsLength === 0) return;
    setCurrentIndex(prev => (prev + 1) % itemsLength);
  }, [itemsLength]);

  const prevSlide = useCallback(() => {
    if (itemsLength === 0) return;
    setCurrentIndex(prev => (prev - 1 + itemsLength) % itemsLength);
  }, [itemsLength]);

  const goToSlide = useCallback((index: number) => {
    if (index >= 0 && index < itemsLength) {
      setCurrentIndex(index);
    }
  }, [itemsLength]);

  // Usunięto niepotrzebne canScrollPrev i canScrollNext które blokowały przewijanie cykliczne

  return {
    currentIndex,
    nextSlide,
    prevSlide,
    goToSlide
  };
};
